import types from './types';
import * as api from './api';
import { createTrendsActions } from '../../common/trends/actions';

export default createTrendsActions(types, api);
